module.exports = __webpack_public_path__ + "img/Frente-5-01 on.d7acf52c.png";